const specialtyRecipes = [
  // ============================================================
  // BABY FOOD (6 recipes)
  // ============================================================
  {
    title: 'Sweet Potato Puree',
    description: 'A silky smooth sweet potato puree that makes the perfect first food for babies 4-6 months and older. Naturally sweet with no added sugar or salt, packed with beta-carotene and vitamin A for healthy development.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/sweet-potato-puree.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/sweet-potato-puree-prep.jpg', caption: 'Steamed sweet potato cubes ready to blend', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 10,
    cookTime: 20,
    totalTime: 30,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'American',
    region: 'Americas',
    country: 'United States',

    categories: ['Baby Food', 'Baby & Toddler'],
    tags: ['gluten-free', 'dairy-free', 'vegan', 'nut-free', 'egg-free', 'sugar-free', 'low-sodium', 'under-30-min', '5-ingredients-or-less', 'freezer-friendly', 'batch-cooking'],
    ageGroups: ['baby'],
    audience: 'baby',

    nutrition: {
      calories: 55, protein: 1, carbs: 13, fat: 0, fiber: 2, sugar: 4, sodium: 18, iron: 0.4,
    },

    ingredients: [
      { qty: 2, unit: 'medium', item: 'sweet potatoes, peeled and cubed', group: 'Main' },
      { qty: 0.5, unit: 'cup', item: 'water or breast milk', group: 'Main' },
    ],
    steps: [
      { order: 1, instruction: 'Peel sweet potatoes and cut into 1-inch cubes for even cooking.', timerMinutes: null },
      { order: 2, instruction: 'Place sweet potato cubes in a steamer basket over boiling water. Cover and steam until very tender and easily pierced with a fork.', timerMinutes: 15 },
      { order: 3, instruction: 'Transfer steamed sweet potatoes to a blender or food processor. Add water or breast milk a little at a time.', timerMinutes: null },
      { order: 4, instruction: 'Blend until completely smooth with no lumps, scraping down the sides as needed. Add more liquid for a thinner consistency.', timerMinutes: null },
      { order: 5, instruction: 'Let cool to a safe temperature before serving. Test on your wrist to ensure it is lukewarm.', timerMinutes: null },
      { order: 6, instruction: 'Spoon into ice cube trays for freezing individual portions, or store in airtight containers in the refrigerator.', timerMinutes: null },
    ],
    notes: 'NEVER add honey to baby food for children under 1 year due to botulism risk. No added salt or sugar needed. Sweet potatoes are naturally sweet and babies love them. Frozen portions keep for up to 3 months. Thaw in the refrigerator overnight.',

    communityRating: 4.8,
    communityRatingCount: 380,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-03-01').toISOString(),
  },
  {
    title: 'Apple and Banana Mash',
    description: 'A naturally sweet and creamy mash of ripe banana and cooked apple, perfect for babies 4-6 months and older. No added sugar needed thanks to the natural sweetness of the fruit.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/apple-banana-mash.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/apple-banana-mash-prep.jpg', caption: 'Diced apple ready to cook', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 3,
    prepTime: 5,
    cookTime: 10,
    totalTime: 15,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'American',
    region: 'Americas',
    country: 'United States',

    categories: ['Baby Food', 'Baby & Toddler'],
    tags: ['gluten-free', 'dairy-free', 'vegan', 'nut-free', 'egg-free', 'sugar-free', 'low-sodium', 'under-15-min', '5-ingredients-or-less', 'freezer-friendly'],
    ageGroups: ['baby'],
    audience: 'baby',

    nutrition: {
      calories: 50, protein: 0.5, carbs: 13, fat: 0.2, fiber: 1.5, sugar: 9, sodium: 1, iron: 0.2,
    },

    ingredients: [
      { qty: 1, unit: 'medium', item: 'apple, peeled, cored, and diced', group: 'Main' },
      { qty: 1, unit: 'medium', item: 'ripe banana', group: 'Main' },
      { qty: 2, unit: 'tbsp', item: 'water', group: 'Main' },
    ],
    steps: [
      { order: 1, instruction: 'Peel and core the apple, then cut into small dice for quick cooking.', timerMinutes: null },
      { order: 2, instruction: 'Place diced apple in a small saucepan with 2 tablespoons of water. Cover and cook over medium-low heat until very soft.', timerMinutes: 8 },
      { order: 3, instruction: 'Peel the ripe banana and add it to the saucepan with the cooked apple.', timerMinutes: null },
      { order: 4, instruction: 'Mash with a fork for a chunkier texture or blend for a smoother puree, depending on your baby\'s stage.', timerMinutes: null },
      { order: 5, instruction: 'Let cool to a safe lukewarm temperature before serving. Test on your wrist.', timerMinutes: null },
    ],
    notes: 'NEVER add honey for babies under 1 year due to botulism risk. No sugar or salt needed. Use the ripest banana you can find for maximum natural sweetness. Stores in the refrigerator for up to 2 days or freeze in portions for up to 3 months.',

    communityRating: 4.7,
    communityRatingCount: 310,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-03-01').toISOString(),
  },
  {
    title: 'Carrot and Lentil Puree',
    description: 'An iron-rich puree combining sweet carrots with protein-packed red lentils. Ideal for babies 6 months and older who need iron from complementary foods.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/carrot-lentil-puree.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/carrot-lentil-puree-prep.jpg', caption: 'Carrots and lentils simmering', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 10,
    cookTime: 25,
    totalTime: 35,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'British',
    region: 'Europe',
    country: 'United Kingdom',

    categories: ['Baby Food', 'Baby & Toddler'],
    tags: ['high-fiber', 'gluten-free', 'dairy-free', 'vegan', 'nut-free', 'egg-free', 'sugar-free', 'low-sodium', 'freezer-friendly', 'batch-cooking', 'budget-friendly'],
    ageGroups: ['baby'],
    audience: 'baby',

    nutrition: {
      calories: 70, protein: 4, carbs: 13, fat: 0.3, fiber: 3, sugar: 3, sodium: 22, iron: 1.8,
    },

    ingredients: [
      { qty: 2, unit: 'medium', item: 'carrots, peeled and diced', group: 'Main' },
      { qty: 0.5, unit: 'cup', item: 'red lentils, rinsed', group: 'Main' },
      { qty: 1.5, unit: 'cups', item: 'water', group: 'Main' },
      { qty: 0.25, unit: 'tsp', item: 'ground cumin (optional, for 8+ months)', group: 'Seasoning' },
    ],
    steps: [
      { order: 1, instruction: 'Rinse red lentils under cold water until the water runs clear. Peel and dice carrots into small pieces.', timerMinutes: null },
      { order: 2, instruction: 'Place carrots, lentils, and water in a medium saucepan. Bring to a boil over medium-high heat.', timerMinutes: null },
      { order: 3, instruction: 'Reduce heat to low, cover, and simmer until lentils are completely soft and carrots are very tender.', timerMinutes: 20 },
      { order: 4, instruction: 'If using cumin for older babies, stir it in during the last minute of cooking.', timerMinutes: null },
      { order: 5, instruction: 'Transfer to a blender and puree until smooth, adding extra water as needed for desired consistency.', timerMinutes: null },
      { order: 6, instruction: 'Cool to a safe temperature and serve, or portion into ice cube trays for freezing.', timerMinutes: null },
    ],
    notes: 'NEVER add honey for babies under 1 year. No added salt or sugar. Red lentils are an excellent source of iron for babies. Pair with a small amount of vitamin C (a squeeze of orange juice mixed in after cooling) to boost iron absorption. Freeze portions for up to 3 months.',

    communityRating: 4.6,
    communityRatingCount: 275,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-03-01').toISOString(),
  },
  {
    title: 'Avocado Baby Food',
    description: 'Simple mashed avocado packed with healthy fats essential for baby\'s brain development. One of the easiest and most nutritious first foods, ready in minutes with no cooking required.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/avocado-baby-food.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/avocado-baby-food-prep.jpg', caption: 'Ripe avocado halved and ready to mash', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 2,
    prepTime: 5,
    cookTime: 0,
    totalTime: 5,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'American',
    region: 'Americas',
    country: 'United States',

    categories: ['Baby Food', 'Baby & Toddler'],
    tags: ['gluten-free', 'dairy-free', 'vegan', 'nut-free', 'egg-free', 'sugar-free', 'low-sodium', 'no-cook', 'under-15-min', '5-ingredients-or-less'],
    ageGroups: ['baby'],
    audience: 'baby',

    nutrition: {
      calories: 80, protein: 1, carbs: 4, fat: 7, fiber: 3, sugar: 0.3, sodium: 4, iron: 0.3,
    },

    ingredients: [
      { qty: 1, unit: '', item: 'ripe avocado', group: 'Main' },
      { qty: 1, unit: 'tbsp', item: 'breast milk, formula, or water', group: 'Main' },
    ],
    steps: [
      { order: 1, instruction: 'Cut a ripe avocado in half and remove the pit. The avocado should yield easily to gentle pressure.', timerMinutes: null },
      { order: 2, instruction: 'Scoop the flesh into a small bowl.', timerMinutes: null },
      { order: 3, instruction: 'Mash thoroughly with a fork until smooth for younger babies, or leave slightly chunky for babies 8+ months who are practicing textures.', timerMinutes: null },
      { order: 4, instruction: 'Stir in a small amount of breast milk, formula, or water to reach desired consistency.', timerMinutes: null },
      { order: 5, instruction: 'Serve immediately, as avocado browns quickly once exposed to air.', timerMinutes: null },
    ],
    notes: 'NEVER add honey for babies under 1 year. No salt or sugar needed. Avocado does not freeze well as a puree due to browning. Use a perfectly ripe avocado for the best flavor. If avocado is the first food, start with a very small amount to check for any reactions.',

    communityRating: 4.5,
    communityRatingCount: 290,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-03-01').toISOString(),
  },
  {
    title: 'Chicken and Veggie Mash',
    description: 'A protein-rich puree of tender chicken, sweet potato, and peas designed for babies 8 months and older. Provides essential protein and iron to support healthy growth.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/chicken-veggie-mash.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/chicken-veggie-mash-prep.jpg', caption: 'Diced chicken and vegetables ready to cook', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 10,
    cookTime: 25,
    totalTime: 35,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'American',
    region: 'Americas',
    country: 'United States',

    categories: ['Baby Food', 'Baby & Toddler'],
    tags: ['gluten-free', 'dairy-free', 'nut-free', 'egg-free', 'sugar-free', 'low-sodium', 'freezer-friendly', 'batch-cooking'],
    ageGroups: ['baby'],
    audience: 'baby',

    nutrition: {
      calories: 75, protein: 8, carbs: 7, fat: 1.5, fiber: 1.5, sugar: 2, sodium: 30, iron: 0.7,
    },

    ingredients: [
      { qty: 4, unit: 'oz', item: 'boneless skinless chicken breast', group: 'Main' },
      { qty: 1, unit: 'small', item: 'sweet potato, peeled and diced', group: 'Vegetables' },
      { qty: 0.25, unit: 'cup', item: 'frozen peas', group: 'Vegetables' },
      { qty: 1, unit: 'cup', item: 'water', group: 'Main' },
    ],
    steps: [
      { order: 1, instruction: 'Cut chicken breast into small, uniform pieces to ensure even cooking. Peel and dice sweet potato.', timerMinutes: null },
      { order: 2, instruction: 'Place chicken pieces and diced sweet potato in a small saucepan. Cover with water and bring to a boil.', timerMinutes: null },
      { order: 3, instruction: 'Reduce heat, cover, and simmer until chicken is cooked through and sweet potato is very tender.', timerMinutes: 18 },
      { order: 4, instruction: 'Add frozen peas during the last 3 minutes of cooking.', timerMinutes: 3 },
      { order: 5, instruction: 'Reserve the cooking liquid. Transfer chicken, sweet potato, and peas to a blender.', timerMinutes: null },
      { order: 6, instruction: 'Blend until smooth, adding reserved cooking liquid a tablespoon at a time until you reach the right consistency for your baby.', timerMinutes: null },
      { order: 7, instruction: 'Cool to a safe lukewarm temperature. Test on your wrist before serving.', timerMinutes: null },
    ],
    notes: 'NEVER add honey for babies under 1 year. No salt or sugar needed. Suitable for babies 8+ months who have been introduced to single-ingredient purees. Always ensure chicken is fully cooked through to 165 degrees F. Freeze portions for up to 2 months.',

    communityRating: 4.6,
    communityRatingCount: 245,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-03-01').toISOString(),
  },
  {
    title: 'Pea and Mint Puree',
    description: 'A vibrant bright green puree of sweet peas and fresh mint that is naturally rich in iron and vitamin C. A refreshing flavor combination that babies 6 months and older tend to love.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/pea-mint-puree.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/pea-mint-puree-prep.jpg', caption: 'Fresh peas and mint leaves', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 3,
    prepTime: 5,
    cookTime: 5,
    totalTime: 10,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'British',
    region: 'Europe',
    country: 'United Kingdom',

    categories: ['Baby Food', 'Baby & Toddler'],
    tags: ['gluten-free', 'dairy-free', 'vegan', 'nut-free', 'egg-free', 'sugar-free', 'low-sodium', 'under-15-min', '5-ingredients-or-less', 'freezer-friendly'],
    ageGroups: ['baby'],
    audience: 'baby',

    nutrition: {
      calories: 45, protein: 3, carbs: 7, fat: 0.2, fiber: 2.5, sugar: 3, sodium: 3, iron: 1.2,
    },

    ingredients: [
      { qty: 1.5, unit: 'cups', item: 'frozen peas', group: 'Main' },
      { qty: 3, unit: '', item: 'fresh mint leaves', group: 'Main' },
      { qty: 3, unit: 'tbsp', item: 'water or breast milk', group: 'Main' },
    ],
    steps: [
      { order: 1, instruction: 'Bring a small pot of water to a boil. Add frozen peas and cook until very tender.', timerMinutes: 4 },
      { order: 2, instruction: 'Drain peas, reserving a few tablespoons of the cooking water.', timerMinutes: null },
      { order: 3, instruction: 'Transfer peas to a blender with fresh mint leaves and water or breast milk.', timerMinutes: null },
      { order: 4, instruction: 'Blend until completely smooth, adding more liquid as needed. For older babies, you can leave some texture.', timerMinutes: null },
      { order: 5, instruction: 'Push through a fine mesh sieve for the smoothest result, especially for younger babies, as pea skins can be tough.', timerMinutes: null },
      { order: 6, instruction: 'Cool to a safe temperature before serving.', timerMinutes: null },
    ],
    notes: 'NEVER add honey for babies under 1 year. No salt or sugar needed. Peas are a good source of plant-based iron. The mint adds a subtle freshness that many babies enjoy. Freeze portions in ice cube trays for up to 3 months. Pair with a vitamin C source to enhance iron absorption.',

    communityRating: 4.4,
    communityRatingCount: 195,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-03-01').toISOString(),
  },

  // ============================================================
  // TODDLER MEALS (5 recipes)
  // ============================================================
  {
    title: 'Mini Banana Pancakes',
    description: 'Soft, palm-sized pancakes made with ripe bananas and just a few simple ingredients. Perfect for little hands to grab and self-feed, with no added sugar needed.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/mini-banana-pancakes.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/mini-banana-pancakes-prep.jpg', caption: 'Small pancakes cooking on the griddle', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 3,
    prepTime: 10,
    cookTime: 15,
    totalTime: 25,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'American',
    region: 'Americas',
    country: 'United States',

    categories: ['Breakfast', 'Baby & Toddler'],
    tags: ['nut-free', 'sugar-free', 'low-sodium', 'under-30-min', 'freezer-friendly', 'family-friendly'],
    ageGroups: ['toddler', 'kid'],
    audience: 'toddler',

    nutrition: {
      calories: 145, protein: 5, carbs: 22, fat: 4.5, fiber: 1.5, sugar: 7, sodium: 180, iron: 1.1,
    },

    ingredients: [
      { qty: 2, unit: '', item: 'ripe bananas, mashed', group: 'Batter' },
      { qty: 1, unit: 'cup', item: 'all-purpose flour', group: 'Batter' },
      { qty: 1, unit: '', item: 'egg', group: 'Batter' },
      { qty: 0.5, unit: 'cup', item: 'milk', group: 'Batter' },
      { qty: 1, unit: 'tsp', item: 'baking powder', group: 'Batter' },
      { qty: 0.25, unit: 'tsp', item: 'cinnamon', group: 'Batter' },
      { qty: 1, unit: 'tbsp', item: 'butter, for cooking', group: 'Cooking' },
    ],
    steps: [
      { order: 1, instruction: 'Mash the ripe bananas thoroughly in a mixing bowl with a fork until smooth.', timerMinutes: null },
      { order: 2, instruction: 'Add the egg and milk to the mashed bananas and whisk until combined.', timerMinutes: null },
      { order: 3, instruction: 'In a separate bowl, mix flour, baking powder, and cinnamon. Add dry ingredients to the wet mixture and stir until just combined. Do not overmix.', timerMinutes: null },
      { order: 4, instruction: 'Heat a non-stick griddle or pan over medium-low heat. Add a small amount of butter.', timerMinutes: null },
      { order: 5, instruction: 'Drop tablespoon-sized portions of batter onto the griddle to make silver dollar-sized pancakes. Cook until bubbles form on the surface.', timerMinutes: 2 },
      { order: 6, instruction: 'Flip carefully and cook the other side until golden brown.', timerMinutes: 2 },
      { order: 7, instruction: 'Let cool slightly until safe for toddler hands. Serve plain or with a thin smear of nut butter.', timerMinutes: null },
    ],
    notes: 'Keep pancakes small, about 2 inches across, so toddlers can hold them easily. These freeze beautifully; place parchment between layers and freeze for up to 2 months. Reheat in the toaster. Always supervise toddlers while eating.',

    communityRating: 4.8,
    communityRatingCount: 420,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-03-01').toISOString(),
  },
  {
    title: 'Veggie Mac and Cheese',
    description: 'Creamy macaroni and cheese with pureed butternut squash and carrots hidden in the sauce. Toddlers get their beloved mac and cheese while secretly eating two servings of vegetables.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/veggie-mac-and-cheese.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/veggie-mac-and-cheese-prep.jpg', caption: 'Butternut squash and carrots roasting', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 15,
    cookTime: 25,
    totalTime: 40,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'American',
    region: 'Americas',
    country: 'United States',

    categories: ['Lunch', 'Dinner', 'Baby & Toddler'],
    tags: ['vegetarian', 'nut-free', 'low-sodium', 'family-friendly', 'freezer-friendly', 'comfort-food'],
    ageGroups: ['toddler', 'kid'],
    audience: 'toddler',

    nutrition: {
      calories: 220, protein: 9, carbs: 30, fat: 7, fiber: 2.5, sugar: 4, sodium: 210, iron: 1.4,
    },

    ingredients: [
      { qty: 8, unit: 'oz', item: 'elbow macaroni', group: 'Pasta' },
      { qty: 1, unit: 'cup', item: 'butternut squash, peeled and cubed', group: 'Hidden Veggies' },
      { qty: 1, unit: 'medium', item: 'carrot, peeled and chopped', group: 'Hidden Veggies' },
      { qty: 1, unit: 'cup', item: 'milk', group: 'Sauce' },
      { qty: 1, unit: 'cup', item: 'mild cheddar cheese, shredded', group: 'Sauce' },
      { qty: 1, unit: 'tbsp', item: 'butter', group: 'Sauce' },
      { qty: 0.25, unit: 'tsp', item: 'garlic powder', group: 'Sauce' },
    ],
    steps: [
      { order: 1, instruction: 'Place cubed butternut squash and chopped carrot in a saucepan, cover with water, and bring to a boil. Cook until very soft.', timerMinutes: 15 },
      { order: 2, instruction: 'While vegetables cook, bring a separate pot of water to a boil and cook macaroni according to package directions until very soft, slightly past al dente for toddler-friendly texture.', timerMinutes: 10 },
      { order: 3, instruction: 'Drain the cooked vegetables and transfer to a blender. Add milk and blend until completely smooth.', timerMinutes: null },
      { order: 4, instruction: 'In the vegetable saucepan, melt butter over low heat. Pour in the veggie puree and stir in garlic powder.', timerMinutes: null },
      { order: 5, instruction: 'Remove from heat and stir in shredded cheddar cheese until melted and creamy.', timerMinutes: null },
      { order: 6, instruction: 'Drain macaroni and toss with the cheese-veggie sauce until evenly coated.', timerMinutes: null },
      { order: 7, instruction: 'Let cool to a safe temperature for toddlers before serving. Cut any long noodles for smaller eaters.', timerMinutes: null },
    ],
    notes: 'The orange color of the butternut squash blends perfectly with the cheddar so toddlers cannot tell there are vegetables in the sauce. Use mild cheese to keep sodium low. Stores in the refrigerator for up to 3 days. Always cut noodles into small pieces for toddlers under 2.',

    communityRating: 4.9,
    communityRatingCount: 450,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-03-01').toISOString(),
  },
  {
    title: 'Mini Turkey Meatballs',
    description: 'Soft, bite-sized turkey meatballs perfectly portioned for toddlers. Made with hidden grated zucchini for extra moisture and nutrition, these are easy to pick up and gentle on little teeth.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/mini-turkey-meatballs.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/mini-turkey-meatballs-prep.jpg', caption: 'Shaping tiny meatballs', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 15,
    cookTime: 15,
    totalTime: 30,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'American',
    region: 'Americas',
    country: 'United States',

    categories: ['Lunch', 'Dinner', 'Baby & Toddler'],
    tags: ['nut-free', 'low-sodium', 'under-30-min', 'freezer-friendly', 'family-friendly', 'batch-cooking'],
    ageGroups: ['toddler', 'kid'],
    audience: 'toddler',

    nutrition: {
      calories: 135, protein: 14, carbs: 6, fat: 6, fiber: 0.5, sugar: 1, sodium: 160, iron: 1.5,
    },

    ingredients: [
      { qty: 1, unit: 'lb', item: 'ground turkey', group: 'Meatballs' },
      { qty: 0.5, unit: 'cup', item: 'zucchini, finely grated and squeezed dry', group: 'Meatballs' },
      { qty: 0.25, unit: 'cup', item: 'breadcrumbs', group: 'Meatballs' },
      { qty: 1, unit: '', item: 'egg', group: 'Meatballs' },
      { qty: 1, unit: 'tbsp', item: 'olive oil', group: 'Cooking' },
      { qty: 0.25, unit: 'tsp', item: 'garlic powder', group: 'Seasoning' },
      { qty: 0.25, unit: 'tsp', item: 'dried oregano', group: 'Seasoning' },
    ],
    steps: [
      { order: 1, instruction: 'Preheat oven to 375 degrees F. Line a baking sheet with parchment paper and lightly grease with olive oil.', timerMinutes: null },
      { order: 2, instruction: 'Grate the zucchini on the fine side of a box grater. Squeeze out excess moisture using a clean kitchen towel.', timerMinutes: null },
      { order: 3, instruction: 'In a large bowl, combine ground turkey, grated zucchini, breadcrumbs, egg, garlic powder, and oregano. Mix gently until just combined.', timerMinutes: null },
      { order: 4, instruction: 'Roll the mixture into 1-inch balls, about the size of a grape tomato. Place on the prepared baking sheet with space between each.', timerMinutes: null },
      { order: 5, instruction: 'Bake until cooked through and lightly golden on the outside. Internal temperature should reach 165 degrees F.', timerMinutes: 15 },
      { order: 6, instruction: 'Let cool until safe for toddler handling. For younger toddlers, cut each meatball in half or quarters to reduce choking risk.', timerMinutes: null },
    ],
    notes: 'IMPORTANT: Always cut meatballs into smaller pieces for toddlers under 2 to prevent choking. The grated zucchini keeps these meatballs incredibly moist. Freeze cooked meatballs for up to 3 months. Reheat from frozen in the microwave for 30-45 seconds.',

    communityRating: 4.7,
    communityRatingCount: 365,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-03-01').toISOString(),
  },
  {
    title: 'Sweet Potato Fingers',
    description: 'Baked sweet potato fries cut into finger-shaped sticks that are perfect for toddlers practicing self-feeding. Soft on the inside and lightly crisp on the outside, with no added salt.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/sweet-potato-fingers.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/sweet-potato-fingers-prep.jpg', caption: 'Sweet potato sticks ready for the oven', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 3,
    prepTime: 10,
    cookTime: 25,
    totalTime: 35,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'American',
    region: 'Americas',
    country: 'United States',

    categories: ['Snacks', 'Sides', 'Baby & Toddler'],
    tags: ['gluten-free', 'dairy-free', 'vegan', 'nut-free', 'egg-free', 'sugar-free', 'low-sodium', '5-ingredients-or-less', 'family-friendly'],
    ageGroups: ['toddler', 'kid'],
    audience: 'toddler',

    nutrition: {
      calories: 85, protein: 1, carbs: 17, fat: 2, fiber: 2.5, sugar: 5, sodium: 25, iron: 0.5,
    },

    ingredients: [
      { qty: 2, unit: 'medium', item: 'sweet potatoes', group: 'Main' },
      { qty: 1, unit: 'tbsp', item: 'olive oil', group: 'Main' },
      { qty: 0.25, unit: 'tsp', item: 'cinnamon (optional)', group: 'Seasoning' },
    ],
    steps: [
      { order: 1, instruction: 'Preheat oven to 400 degrees F. Line a baking sheet with parchment paper.', timerMinutes: null },
      { order: 2, instruction: 'Peel sweet potatoes and cut into finger-length sticks, about half an inch thick. Keep sizes uniform for even cooking.', timerMinutes: null },
      { order: 3, instruction: 'Toss sweet potato sticks with olive oil and cinnamon if using. Spread in a single layer on the baking sheet.', timerMinutes: null },
      { order: 4, instruction: 'Bake, flipping halfway through, until soft inside and lightly golden outside.', timerMinutes: 25 },
      { order: 5, instruction: 'Let cool until safe to handle. Test softness by squeezing gently; they should give easily for little mouths.', timerMinutes: null },
    ],
    notes: 'No salt needed; sweet potatoes have a naturally appealing flavor for toddlers. Cut into finger-length sticks that are easy for small hands to grip. For babies 6-9 months doing baby-led weaning, make the sticks wider so they can palm-grip them. Always supervise during eating.',

    communityRating: 4.5,
    communityRatingCount: 280,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-03-01').toISOString(),
  },
  {
    title: 'Fruit and Yogurt Popsicles',
    description: 'Frozen treats made from creamy yogurt blended with real fruit, a healthy alternative to sugary store-bought popsicles. Toddlers love them and parents love the hidden nutrition.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/fruit-yogurt-popsicles.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/fruit-yogurt-popsicles-prep.jpg', caption: 'Blended mixture being poured into molds', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 10,
    cookTime: 0,
    totalTime: 10,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'American',
    region: 'Americas',
    country: 'United States',

    categories: ['Snacks', 'Dessert', 'Baby & Toddler'],
    tags: ['vegetarian', 'gluten-free', 'nut-free', 'egg-free', 'sugar-free', 'low-sodium', 'no-cook', 'under-15-min', '5-ingredients-or-less', 'make-ahead', 'family-friendly'],
    ageGroups: ['toddler', 'kid'],
    audience: 'toddler',

    nutrition: {
      calories: 70, protein: 3, carbs: 13, fat: 1.5, fiber: 1, sugar: 10, sodium: 30, iron: 0.2,
    },

    ingredients: [
      { qty: 1, unit: 'cup', item: 'plain whole-milk yogurt', group: 'Base' },
      { qty: 0.5, unit: 'cup', item: 'ripe strawberries, hulled', group: 'Fruit' },
      { qty: 0.5, unit: 'cup', item: 'ripe banana, sliced', group: 'Fruit' },
      { qty: 0.25, unit: 'cup', item: 'blueberries', group: 'Fruit' },
    ],
    steps: [
      { order: 1, instruction: 'Combine yogurt, strawberries, banana slices, and blueberries in a blender.', timerMinutes: null },
      { order: 2, instruction: 'Blend until completely smooth with no chunks that could be a choking hazard.', timerMinutes: null },
      { order: 3, instruction: 'Pour the mixture into popsicle molds, leaving a small gap at the top for expansion.', timerMinutes: null },
      { order: 4, instruction: 'Insert popsicle sticks and freeze until solid, at least 4 hours or overnight.', timerMinutes: null },
      { order: 5, instruction: 'To unmold, run warm water over the outside of the mold for a few seconds until the popsicle loosens.', timerMinutes: null },
    ],
    notes: 'No added sugar needed as the ripe fruit provides all the sweetness. Use whole-milk yogurt for toddlers as they need the healthy fats. For younger toddlers, use silicone popsicle molds designed for small hands. Always supervise to prevent biting off large chunks. Keeps in the freezer for up to 1 month.',

    communityRating: 4.6,
    communityRatingCount: 340,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-03-01').toISOString(),
  },

  // ============================================================
  // TEEN QUICK MEALS (5 recipes)
  // ============================================================
  {
    title: 'Loaded Nachos',
    description: 'Crispy tortilla chips piled high with seasoned beef, melty cheese, and all your favorite toppings. A customizable game-day favorite that teens can make themselves.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/loaded-nachos.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/loaded-nachos-prep.jpg', caption: 'Layering chips and toppings', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 10,
    cookTime: 15,
    totalTime: 25,
    difficulty: 'easy',
    spiceLevel: 1,

    cuisine: 'Mexican',
    region: 'Americas',
    country: 'Mexico',

    categories: ['Snacks', 'Appetizers', 'Family Meals'],
    tags: ['gluten-free', 'under-30-min', 'family-friendly', 'game-day', 'party', 'comfort-food'],
    ageGroups: ['kid', 'teen', 'adult'],
    audience: 'family',

    nutrition: {
      calories: 480, protein: 22, carbs: 38, fat: 26, fiber: 5, sugar: 3, sodium: 780, iron: 3.0,
    },

    ingredients: [
      { qty: 1, unit: 'lb', item: 'ground beef', group: 'Meat' },
      { qty: 1, unit: 'bag (13 oz)', item: 'tortilla chips', group: 'Base' },
      { qty: 2, unit: 'cups', item: 'shredded Mexican blend cheese', group: 'Toppings' },
      { qty: 1, unit: 'can (15 oz)', item: 'black beans, drained and rinsed', group: 'Toppings' },
      { qty: 1, unit: 'packet', item: 'taco seasoning', group: 'Seasoning' },
      { qty: 1, unit: '', item: 'tomato, diced', group: 'Fresh Toppings' },
      { qty: 0.5, unit: 'cup', item: 'sour cream', group: 'Fresh Toppings' },
      { qty: 1, unit: '', item: 'avocado, diced', group: 'Fresh Toppings' },
      { qty: 2, unit: '', item: 'green onions, sliced', group: 'Fresh Toppings' },
      { qty: 0.25, unit: 'cup', item: 'pickled jalapenos (optional)', group: 'Fresh Toppings' },
    ],
    steps: [
      { order: 1, instruction: 'Preheat oven to 400 degrees F. Line a large baking sheet with aluminum foil for easy cleanup.', timerMinutes: null },
      { order: 2, instruction: 'Brown the ground beef in a skillet over medium-high heat, breaking it up as it cooks. Drain excess fat.', timerMinutes: 8 },
      { order: 3, instruction: 'Stir in taco seasoning according to packet directions with the recommended amount of water. Simmer until thickened.', timerMinutes: 3 },
      { order: 4, instruction: 'Spread tortilla chips in an even layer on the baking sheet. Top with seasoned beef, black beans, and shredded cheese.', timerMinutes: null },
      { order: 5, instruction: 'Bake until the cheese is fully melted and bubbly.', timerMinutes: 5 },
      { order: 6, instruction: 'Remove from oven and top with diced tomato, avocado, green onions, sour cream, and jalapenos if desired.', timerMinutes: null },
    ],
    notes: 'Pro tip: layer the nachos in two rounds for maximum coverage. Put down half the chips and half the toppings, then repeat. This way every chip gets loaded. Customize with whatever toppings you like.',

    communityRating: 4.7,
    communityRatingCount: 410,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-03-01').toISOString(),
  },
  {
    title: 'Smoothie Bowl',
    description: 'A thick, creamy smoothie served in a bowl and loaded with crunchy granola, fresh fruit, and toppings. Like eating a delicious dessert for breakfast but packed with nutrition.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/smoothie-bowl.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/smoothie-bowl-prep.jpg', caption: 'Arranging toppings on the smoothie base', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 2,
    prepTime: 10,
    cookTime: 0,
    totalTime: 10,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'American',
    region: 'Americas',
    country: 'United States',

    categories: ['Breakfast', 'Snacks', 'Family Meals'],
    tags: ['vegetarian', 'gluten-free', 'no-cook', 'under-15-min', 'high-fiber', 'family-friendly'],
    ageGroups: ['kid', 'teen', 'adult'],
    audience: 'family',

    nutrition: {
      calories: 320, protein: 10, carbs: 55, fat: 8, fiber: 7, sugar: 32, sodium: 65, iron: 2.0,
    },

    ingredients: [
      { qty: 2, unit: 'cups', item: 'frozen mixed berries', group: 'Smoothie Base' },
      { qty: 1, unit: '', item: 'frozen banana', group: 'Smoothie Base' },
      { qty: 0.5, unit: 'cup', item: 'yogurt', group: 'Smoothie Base' },
      { qty: 0.25, unit: 'cup', item: 'milk', group: 'Smoothie Base' },
      { qty: 1, unit: 'tbsp', item: 'honey', group: 'Smoothie Base' },
      { qty: 0.5, unit: 'cup', item: 'granola', group: 'Toppings' },
      { qty: 0.25, unit: 'cup', item: 'fresh blueberries', group: 'Toppings' },
      { qty: 0.25, unit: 'cup', item: 'sliced strawberries', group: 'Toppings' },
      { qty: 1, unit: 'tbsp', item: 'chia seeds', group: 'Toppings' },
      { qty: 1, unit: 'tbsp', item: 'shredded coconut', group: 'Toppings' },
    ],
    steps: [
      { order: 1, instruction: 'Add frozen berries, frozen banana, yogurt, milk, and honey to a blender.', timerMinutes: null },
      { order: 2, instruction: 'Blend until thick and creamy, using the tamper or stopping to scrape down sides. The consistency should be thicker than a drinkable smoothie, like soft-serve ice cream.', timerMinutes: null },
      { order: 3, instruction: 'Use as little liquid as possible. If too thick to blend, add milk one tablespoon at a time.', timerMinutes: null },
      { order: 4, instruction: 'Divide between two bowls, smoothing the tops flat.', timerMinutes: null },
      { order: 5, instruction: 'Arrange toppings in rows across the surface: a stripe of granola, fresh berries, chia seeds, and coconut.', timerMinutes: null },
      { order: 6, instruction: 'Serve immediately before it melts.', timerMinutes: null },
    ],
    notes: 'The key to a good smoothie bowl is using frozen fruit and minimal liquid so it stays thick enough to support toppings. Freeze overripe bananas in advance. Get creative with toppings: nut butters, cacao nibs, hemp seeds, or sliced almonds all work great.',

    communityRating: 4.5,
    communityRatingCount: 350,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-03-01').toISOString(),
  },
  {
    title: 'Sheet Pan Chicken Fajitas',
    description: 'Easy one-pan chicken fajitas with colorful bell peppers and onions, all roasted on a single sheet pan. Perfect for teens learning to cook, with minimal cleanup required.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/sheet-pan-chicken-fajitas.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/sheet-pan-chicken-fajitas-prep.jpg', caption: 'Seasoned chicken and peppers on sheet pan', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 15,
    cookTime: 25,
    totalTime: 40,
    difficulty: 'easy',
    spiceLevel: 1,

    cuisine: 'Mexican',
    region: 'Americas',
    country: 'Mexico',

    categories: ['Dinner', 'Family Meals'],
    tags: ['high-protein', 'gluten-free', 'dairy-free', 'sheet-pan', 'under-30-min', 'weeknight-dinner', 'family-friendly'],
    ageGroups: ['kid', 'teen', 'adult'],
    audience: 'family',

    nutrition: {
      calories: 380, protein: 32, carbs: 28, fat: 14, fiber: 4, sugar: 5, sodium: 620, iron: 2.5,
    },

    ingredients: [
      { qty: 1.5, unit: 'lbs', item: 'boneless skinless chicken breast, sliced into strips', group: 'Main' },
      { qty: 3, unit: '', item: 'bell peppers (mixed colors), sliced', group: 'Vegetables' },
      { qty: 1, unit: 'large', item: 'onion, sliced', group: 'Vegetables' },
      { qty: 3, unit: 'tbsp', item: 'olive oil', group: 'Main' },
      { qty: 1, unit: 'tbsp', item: 'chili powder', group: 'Seasoning' },
      { qty: 1, unit: 'tsp', item: 'cumin', group: 'Seasoning' },
      { qty: 1, unit: 'tsp', item: 'garlic powder', group: 'Seasoning' },
      { qty: 0.5, unit: 'tsp', item: 'smoked paprika', group: 'Seasoning' },
      { qty: 0.5, unit: 'tsp', item: 'salt', group: 'Seasoning' },
      { qty: 1, unit: '', item: 'lime, juiced', group: 'Finishing' },
      { qty: 8, unit: '', item: 'flour tortillas, warmed', group: 'Serving' },
      { qty: 0.5, unit: 'cup', item: 'shredded cheese', group: 'Serving' },
      { qty: 0.5, unit: 'cup', item: 'sour cream', group: 'Serving' },
    ],
    steps: [
      { order: 1, instruction: 'Preheat oven to 425 degrees F. Line a large rimmed baking sheet with aluminum foil and lightly spray with cooking spray.', timerMinutes: null },
      { order: 2, instruction: 'In a large bowl, combine chili powder, cumin, garlic powder, smoked paprika, and salt. Add olive oil and mix.', timerMinutes: null },
      { order: 3, instruction: 'Add sliced chicken, bell peppers, and onion to the bowl. Toss until everything is evenly coated with the seasoning mixture.', timerMinutes: null },
      { order: 4, instruction: 'Spread everything in a single layer on the prepared baking sheet. Avoid overcrowding for the best browning.', timerMinutes: null },
      { order: 5, instruction: 'Roast until chicken is cooked through (165 degrees F) and vegetables are tender with charred edges.', timerMinutes: 25 },
      { order: 6, instruction: 'Remove from oven and squeeze fresh lime juice over everything.', timerMinutes: null },
      { order: 7, instruction: 'Serve in warm tortillas with shredded cheese, sour cream, and any other desired toppings.', timerMinutes: null },
    ],
    notes: 'One sheet pan means one thing to wash. For extra-charred peppers, broil for the last 2 minutes. This recipe is great for meal prep; store the cooked chicken and veggies in the fridge for up to 4 days.',

    communityRating: 4.8,
    communityRatingCount: 395,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-03-01').toISOString(),
  },
  {
    title: 'Energy Protein Balls',
    description: 'No-bake energy bites packed with oats, peanut butter, and chocolate chips. The perfect grab-and-go after-school snack that tastes like cookie dough but fuels you through homework and practice.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/energy-protein-balls.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/energy-protein-balls-prep.jpg', caption: 'Rolling the mixture into balls', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 6,
    prepTime: 15,
    cookTime: 0,
    totalTime: 15,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'American',
    region: 'Americas',
    country: 'United States',

    categories: ['Snacks'],
    tags: ['vegetarian', 'no-cook', 'under-15-min', 'make-ahead', 'high-fiber', 'lunchbox', 'meal-prep', 'freezer-friendly'],
    ageGroups: ['kid', 'teen', 'adult'],

    nutrition: {
      calories: 185, protein: 7, carbs: 22, fat: 9, fiber: 3, sugar: 10, sodium: 85, iron: 1.5,
    },

    ingredients: [
      { qty: 1, unit: 'cup', item: 'old-fashioned rolled oats', group: 'Dry' },
      { qty: 0.5, unit: 'cup', item: 'peanut butter', group: 'Wet' },
      { qty: 0.25, unit: 'cup', item: 'honey', group: 'Wet' },
      { qty: 0.25, unit: 'cup', item: 'mini chocolate chips', group: 'Mix-ins' },
      { qty: 2, unit: 'tbsp', item: 'ground flaxseed', group: 'Dry' },
      { qty: 2, unit: 'tbsp', item: 'hemp seeds', group: 'Dry' },
      { qty: 1, unit: 'tsp', item: 'vanilla extract', group: 'Wet' },
      { qty: 0.25, unit: 'tsp', item: 'cinnamon', group: 'Dry' },
    ],
    steps: [
      { order: 1, instruction: 'Combine rolled oats, ground flaxseed, hemp seeds, and cinnamon in a large mixing bowl.', timerMinutes: null },
      { order: 2, instruction: 'Add peanut butter, honey, and vanilla extract. Stir until the mixture is evenly combined and holds together.', timerMinutes: null },
      { order: 3, instruction: 'Fold in the mini chocolate chips until evenly distributed throughout the mixture.', timerMinutes: null },
      { order: 4, instruction: 'Refrigerate the mixture for 15 minutes if it is too sticky to handle.', timerMinutes: 15 },
      { order: 5, instruction: 'Roll the mixture into 1-inch balls using slightly damp hands to prevent sticking. You should get about 18 balls.', timerMinutes: null },
      { order: 6, instruction: 'Place on a parchment-lined tray and refrigerate for at least 30 minutes to set.', timerMinutes: 30 },
      { order: 7, instruction: 'Store in an airtight container in the refrigerator for up to one week, or freeze for up to 3 months.', timerMinutes: null },
    ],
    notes: 'Swap peanut butter for almond butter or sunflower seed butter for different flavors or nut-free needs. Add a scoop of protein powder for extra protein. These are perfect for pre-game fuel or post-workout recovery. Keep them in the fridge so the chocolate chips stay firm.',

    communityRating: 4.6,
    communityRatingCount: 375,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-03-01').toISOString(),
  },
  {
    title: 'Ramen Upgrade',
    description: 'Turn a packet of instant ramen into a gourmet-style bowl with a soft-boiled egg, fresh vegetables, and a flavorful broth. Quick enough for a weeknight dinner but impressive enough to share on social media.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/ramen-upgrade.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/ramen-upgrade-prep.jpg', caption: 'Soft-boiled egg and fresh toppings ready', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 2,
    prepTime: 5,
    cookTime: 15,
    totalTime: 20,
    difficulty: 'easy',
    spiceLevel: 1,

    cuisine: 'Japanese',
    region: 'Asia',
    country: 'Japan',

    categories: ['Dinner', 'Lunch'],
    tags: ['dairy-free', 'under-30-min', 'budget-friendly', 'weeknight-dinner', 'comfort-food'],
    ageGroups: ['kid', 'teen', 'adult'],

    nutrition: {
      calories: 420, protein: 18, carbs: 48, fat: 16, fiber: 3, sugar: 4, sodium: 890, iron: 2.8,
    },

    ingredients: [
      { qty: 2, unit: 'packets', item: 'instant ramen noodles (discard one seasoning packet)', group: 'Noodles' },
      { qty: 2, unit: '', item: 'eggs', group: 'Toppings' },
      { qty: 3, unit: 'cups', item: 'chicken broth', group: 'Broth' },
      { qty: 1, unit: 'tbsp', item: 'soy sauce', group: 'Broth' },
      { qty: 1, unit: 'tsp', item: 'sesame oil', group: 'Broth' },
      { qty: 1, unit: 'tsp', item: 'sriracha (optional)', group: 'Broth' },
      { qty: 1, unit: 'cup', item: 'baby spinach', group: 'Vegetables' },
      { qty: 0.5, unit: 'cup', item: 'corn kernels', group: 'Vegetables' },
      { qty: 2, unit: '', item: 'green onions, sliced', group: 'Toppings' },
      { qty: 1, unit: 'tsp', item: 'sesame seeds', group: 'Toppings' },
    ],
    steps: [
      { order: 1, instruction: 'Bring a small pot of water to a boil. Gently lower eggs into the water and cook for exactly 7 minutes for a jammy soft-boiled egg.', timerMinutes: 7 },
      { order: 2, instruction: 'Transfer eggs immediately to an ice bath. Let them cool while you prepare the ramen.', timerMinutes: null },
      { order: 3, instruction: 'In a medium saucepan, bring chicken broth to a boil. Add one ramen seasoning packet (use only one for two servings to reduce sodium), soy sauce, and sesame oil.', timerMinutes: null },
      { order: 4, instruction: 'Add ramen noodles to the broth and cook according to package directions, about 3 minutes. Do not overcook.', timerMinutes: 3 },
      { order: 5, instruction: 'During the last minute of cooking, add baby spinach and corn kernels to the broth.', timerMinutes: null },
      { order: 6, instruction: 'Divide noodles and broth between two bowls. Peel the soft-boiled eggs, cut in half, and place on top.', timerMinutes: null },
      { order: 7, instruction: 'Garnish with sliced green onions, sesame seeds, and sriracha if desired.', timerMinutes: null },
    ],
    notes: 'The trick to a perfect soft-boiled egg is the 7-minute cook time and immediate ice bath. Use only one seasoning packet for two servings to keep the sodium in check. Add whatever vegetables you have on hand: mushrooms, bok choy, and bean sprouts all work great.',

    communityRating: 4.7,
    communityRatingCount: 430,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-03-01').toISOString(),
  },

  // ============================================================
  // HIGH PROTEIN (5 recipes)
  // ============================================================
  {
    title: 'Grilled Salmon with Quinoa',
    description: 'Perfectly grilled salmon fillet served over fluffy quinoa with roasted vegetables. An omega-3 rich power meal that delivers over 40 grams of protein per serving.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/grilled-salmon-quinoa.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/grilled-salmon-quinoa-prep.jpg', caption: 'Salmon fillets seasoned and ready for the grill', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 15,
    cookTime: 25,
    totalTime: 40,
    difficulty: 'medium',
    spiceLevel: 0,

    cuisine: 'American',
    region: 'Americas',
    country: 'United States',

    categories: ['Dinner'],
    tags: ['high-protein', 'gluten-free', 'dairy-free', 'pescatarian', 'high-fiber', 'grilling', 'meal-prep', 'weeknight-dinner'],
    ageGroups: ['teen', 'adult'],

    nutrition: {
      calories: 520, protein: 42, carbs: 38, fat: 20, fiber: 5, sugar: 4, sodium: 480, iron: 3.5,
    },

    ingredients: [
      { qty: 4, unit: '', item: 'salmon fillets (6 oz each)', group: 'Fish' },
      { qty: 1, unit: 'cup', item: 'quinoa, rinsed', group: 'Grain' },
      { qty: 2, unit: 'cups', item: 'water', group: 'Grain' },
      { qty: 2, unit: 'cups', item: 'broccoli florets', group: 'Vegetables' },
      { qty: 1, unit: 'cup', item: 'cherry tomatoes, halved', group: 'Vegetables' },
      { qty: 3, unit: 'tbsp', item: 'olive oil, divided', group: 'Main' },
      { qty: 2, unit: 'cloves', item: 'garlic, minced', group: 'Seasoning' },
      { qty: 1, unit: '', item: 'lemon, zested and juiced', group: 'Seasoning' },
      { qty: 1, unit: 'tsp', item: 'dried dill', group: 'Seasoning' },
      { qty: 0.5, unit: 'tsp', item: 'salt', group: 'Seasoning' },
      { qty: 0.25, unit: 'tsp', item: 'black pepper', group: 'Seasoning' },
    ],
    steps: [
      { order: 1, instruction: 'Rinse quinoa under cold water. Combine with 2 cups of water in a saucepan, bring to a boil, reduce heat, cover, and simmer until water is absorbed and quinoa is fluffy.', timerMinutes: 15 },
      { order: 2, instruction: 'While quinoa cooks, pat salmon fillets dry. Brush with 1 tablespoon olive oil and season with salt, pepper, dill, lemon zest, and half the lemon juice.', timerMinutes: null },
      { order: 3, instruction: 'Toss broccoli florets and cherry tomatoes with 1 tablespoon olive oil, minced garlic, and a pinch of salt.', timerMinutes: null },
      { order: 4, instruction: 'Preheat grill or grill pan to medium-high heat. Grill salmon skin-side down for 4-5 minutes, then flip and cook until the internal temperature reaches 145 degrees F.', timerMinutes: 10 },
      { order: 5, instruction: 'While salmon grills, roast the vegetables on a sheet pan at 425 degrees F or in a skillet with the remaining olive oil until tender and lightly charred.', timerMinutes: 12 },
      { order: 6, instruction: 'Fluff the quinoa with a fork and divide among plates. Top with roasted vegetables and a grilled salmon fillet.', timerMinutes: null },
      { order: 7, instruction: 'Drizzle with remaining lemon juice and a thread of olive oil before serving.', timerMinutes: null },
    ],
    notes: 'Wild-caught salmon has a higher omega-3 content than farmed. Do not overcook the salmon; it should still be slightly translucent in the center for the best texture. Quinoa can be made ahead and refrigerated for up to 5 days.',

    communityRating: 4.7,
    communityRatingCount: 320,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-03-01').toISOString(),
  },
  {
    title: 'Greek Yogurt Chicken',
    description: 'Chicken thighs marinated in a tangy Greek yogurt and herb mixture, then baked until golden and incredibly juicy. The yogurt tenderizes the meat while creating a flavorful crust.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/greek-yogurt-chicken.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/greek-yogurt-chicken-prep.jpg', caption: 'Chicken marinating in yogurt mixture', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 15,
    cookTime: 35,
    totalTime: 50,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'Greek',
    region: 'Europe',
    country: 'Greece',

    categories: ['Dinner'],
    tags: ['high-protein', 'gluten-free', 'low-carb', 'make-ahead', 'weeknight-dinner', 'meal-prep'],
    ageGroups: ['teen', 'adult'],

    nutrition: {
      calories: 385, protein: 38, carbs: 6, fat: 22, fiber: 1, sugar: 3, sodium: 520, iron: 2.2,
    },

    ingredients: [
      { qty: 8, unit: '', item: 'bone-in chicken thighs', group: 'Main' },
      { qty: 1, unit: 'cup', item: 'plain Greek yogurt', group: 'Marinade' },
      { qty: 3, unit: 'cloves', item: 'garlic, minced', group: 'Marinade' },
      { qty: 2, unit: 'tbsp', item: 'olive oil', group: 'Marinade' },
      { qty: 1, unit: 'tbsp', item: 'lemon juice', group: 'Marinade' },
      { qty: 1, unit: 'tsp', item: 'dried oregano', group: 'Marinade' },
      { qty: 1, unit: 'tsp', item: 'smoked paprika', group: 'Marinade' },
      { qty: 0.5, unit: 'tsp', item: 'cumin', group: 'Marinade' },
      { qty: 0.5, unit: 'tsp', item: 'salt', group: 'Seasoning' },
      { qty: 0.25, unit: 'tsp', item: 'black pepper', group: 'Seasoning' },
      { qty: 1, unit: 'tbsp', item: 'fresh dill, chopped', group: 'Garnish' },
    ],
    steps: [
      { order: 1, instruction: 'In a large bowl, combine Greek yogurt, minced garlic, olive oil, lemon juice, oregano, smoked paprika, cumin, salt, and pepper. Mix well.', timerMinutes: null },
      { order: 2, instruction: 'Add chicken thighs and coat thoroughly with the yogurt marinade. Cover and refrigerate for at least 1 hour, or ideally overnight.', timerMinutes: null },
      { order: 3, instruction: 'Preheat oven to 425 degrees F. Remove chicken from the refrigerator 20 minutes before baking to take the chill off.', timerMinutes: null },
      { order: 4, instruction: 'Place chicken thighs skin-side up on a parchment-lined baking sheet. Scrape off excess marinade but leave a thin coating.', timerMinutes: null },
      { order: 5, instruction: 'Bake until the skin is golden brown and crispy and the internal temperature reaches 175 degrees F.', timerMinutes: 35 },
      { order: 6, instruction: 'Let rest for 5 minutes before serving. Garnish with fresh dill.', timerMinutes: 5 },
    ],
    notes: 'The longer the chicken marinates, the more tender and flavorful it will be. Overnight is ideal. The acidity in the yogurt breaks down proteins for incredibly juicy meat. Serve with rice pilaf, roasted potatoes, or a Greek salad.',

    communityRating: 4.6,
    communityRatingCount: 285,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-03-01').toISOString(),
  },
  {
    title: 'Turkey and Black Bean Bowl',
    description: 'A lean protein powerhouse bowl with seasoned ground turkey, black beans, brown rice, and fresh toppings. Simple to prepare and ideal for meal prepping an entire week of lunches.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/turkey-black-bean-bowl.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/turkey-black-bean-bowl-prep.jpg', caption: 'Seasoned turkey and beans cooking', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 10,
    cookTime: 25,
    totalTime: 35,
    difficulty: 'easy',
    spiceLevel: 1,

    cuisine: 'Mexican',
    region: 'Americas',
    country: 'United States',

    categories: ['Lunch', 'Dinner'],
    tags: ['high-protein', 'high-fiber', 'gluten-free', 'dairy-free', 'meal-prep', 'batch-cooking', 'budget-friendly', 'weeknight-dinner'],
    ageGroups: ['teen', 'adult'],

    nutrition: {
      calories: 465, protein: 38, carbs: 48, fat: 12, fiber: 10, sugar: 3, sodium: 580, iron: 4.0,
    },

    ingredients: [
      { qty: 1.25, unit: 'lbs', item: 'lean ground turkey', group: 'Protein' },
      { qty: 1, unit: 'can (15 oz)', item: 'black beans, drained and rinsed', group: 'Protein' },
      { qty: 2, unit: 'cups', item: 'brown rice, cooked', group: 'Grain' },
      { qty: 1, unit: 'tbsp', item: 'olive oil', group: 'Cooking' },
      { qty: 1, unit: 'tbsp', item: 'chili powder', group: 'Seasoning' },
      { qty: 1, unit: 'tsp', item: 'cumin', group: 'Seasoning' },
      { qty: 0.5, unit: 'tsp', item: 'garlic powder', group: 'Seasoning' },
      { qty: 0.5, unit: 'tsp', item: 'salt', group: 'Seasoning' },
      { qty: 1, unit: 'cup', item: 'corn kernels', group: 'Toppings' },
      { qty: 1, unit: '', item: 'avocado, diced', group: 'Toppings' },
      { qty: 0.5, unit: 'cup', item: 'salsa', group: 'Toppings' },
      { qty: 0.25, unit: 'cup', item: 'fresh cilantro, chopped', group: 'Toppings' },
      { qty: 1, unit: '', item: 'lime, cut into wedges', group: 'Toppings' },
    ],
    steps: [
      { order: 1, instruction: 'Cook brown rice according to package directions if not already prepared. Set aside.', timerMinutes: null },
      { order: 2, instruction: 'Heat olive oil in a large skillet over medium-high heat. Add ground turkey and cook, breaking it up with a spatula, until browned and no longer pink.', timerMinutes: 8 },
      { order: 3, instruction: 'Stir in chili powder, cumin, garlic powder, and salt. Cook for 1 minute until fragrant.', timerMinutes: 1 },
      { order: 4, instruction: 'Add drained black beans and corn kernels to the skillet. Stir to combine and cook until heated through.', timerMinutes: 3 },
      { order: 5, instruction: 'Divide cooked brown rice among four bowls. Top with the turkey and black bean mixture.', timerMinutes: null },
      { order: 6, instruction: 'Add diced avocado, salsa, and fresh cilantro on top. Squeeze lime over each bowl before serving.', timerMinutes: null },
    ],
    notes: 'For meal prep, store the turkey-bean mixture and rice in separate containers. Add fresh toppings when ready to eat. The turkey-bean mixture keeps well in the fridge for 5 days. Use 99% lean turkey for the lowest fat content.',

    communityRating: 4.5,
    communityRatingCount: 265,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-03-01').toISOString(),
  },
  {
    title: 'Lentil Power Bowl',
    description: 'A plant-based protein powerhouse featuring spiced lentils, roasted sweet potatoes, fresh greens, and a tahini drizzle. Delivers over 30 grams of protein entirely from plants.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/lentil-power-bowl.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/lentil-power-bowl-prep.jpg', caption: 'Roasted sweet potatoes and cooked lentils', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 15,
    cookTime: 35,
    totalTime: 50,
    difficulty: 'easy',
    spiceLevel: 1,

    cuisine: 'Mediterranean',
    region: 'Middle East',
    country: 'Lebanon',

    categories: ['Lunch', 'Dinner'],
    tags: ['high-protein', 'high-fiber', 'high-iron', 'vegan', 'gluten-free', 'dairy-free', 'nut-free', 'meal-prep', 'budget-friendly'],
    ageGroups: ['teen', 'adult'],

    nutrition: {
      calories: 520, protein: 31, carbs: 68, fat: 13, fiber: 18, sugar: 10, sodium: 410, iron: 7.8,
    },

    ingredients: [
      { qty: 1.5, unit: 'cups', item: 'green or brown lentils, rinsed', group: 'Lentils' },
      { qty: 3, unit: 'cups', item: 'water', group: 'Lentils' },
      { qty: 2, unit: 'medium', item: 'sweet potatoes, cubed', group: 'Roasted Vegetables' },
      { qty: 1, unit: 'can (15 oz)', item: 'chickpeas, drained and rinsed', group: 'Protein' },
      { qty: 3, unit: 'tbsp', item: 'olive oil, divided', group: 'Main' },
      { qty: 1, unit: 'tsp', item: 'cumin', group: 'Seasoning' },
      { qty: 1, unit: 'tsp', item: 'smoked paprika', group: 'Seasoning' },
      { qty: 0.5, unit: 'tsp', item: 'turmeric', group: 'Seasoning' },
      { qty: 0.5, unit: 'tsp', item: 'salt', group: 'Seasoning' },
      { qty: 4, unit: 'cups', item: 'baby spinach or kale', group: 'Greens' },
      { qty: 2, unit: 'tbsp', item: 'tahini', group: 'Dressing' },
      { qty: 1, unit: 'tbsp', item: 'lemon juice', group: 'Dressing' },
      { qty: 1, unit: 'tbsp', item: 'water', group: 'Dressing' },
    ],
    steps: [
      { order: 1, instruction: 'Preheat oven to 425 degrees F. Toss cubed sweet potatoes and drained chickpeas with 2 tablespoons olive oil, cumin, smoked paprika, and a pinch of salt. Spread on a baking sheet.', timerMinutes: null },
      { order: 2, instruction: 'Roast until sweet potatoes are tender and chickpeas are slightly crispy.', timerMinutes: 30 },
      { order: 3, instruction: 'While vegetables roast, combine lentils and water in a saucepan. Bring to a boil, reduce heat, and simmer until tender but not mushy.', timerMinutes: 25 },
      { order: 4, instruction: 'Drain any excess water from lentils and season with remaining olive oil, turmeric, and salt.', timerMinutes: null },
      { order: 5, instruction: 'Make the tahini dressing by whisking together tahini, lemon juice, and water until smooth and drizzleable.', timerMinutes: null },
      { order: 6, instruction: 'Divide baby spinach among four bowls. Top with seasoned lentils, roasted sweet potatoes, and crispy chickpeas.', timerMinutes: null },
      { order: 7, instruction: 'Drizzle with tahini dressing and serve. Add a squeeze of extra lemon if desired.', timerMinutes: null },
    ],
    notes: 'Lentils and chickpeas together provide a complete protein with all essential amino acids. The vitamin C in the lemon juice helps your body absorb the plant-based iron. This bowl keeps well in the fridge for 4 days, making it ideal for meal prep.',

    communityRating: 4.4,
    communityRatingCount: 210,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-03-01').toISOString(),
  },
  {
    title: 'Tuna Poke Bowl',
    description: 'A fresh and vibrant Hawaiian-style poke bowl with sushi-grade tuna, seasoned rice, and crunchy toppings. High in protein and omega-3 fatty acids, this no-cook protein bowl comes together fast.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/tuna-poke-bowl.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/tuna-poke-bowl-prep.jpg', caption: 'Cubed tuna marinating in poke sauce', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 20,
    cookTime: 20,
    totalTime: 40,
    difficulty: 'medium',
    spiceLevel: 1,

    cuisine: 'Hawaiian',
    region: 'Americas',
    country: 'United States',

    categories: ['Lunch', 'Dinner'],
    tags: ['high-protein', 'dairy-free', 'pescatarian', 'under-30-min'],
    ageGroups: ['teen', 'adult'],

    nutrition: {
      calories: 475, protein: 36, carbs: 52, fat: 12, fiber: 4, sugar: 8, sodium: 720, iron: 2.5,
    },

    ingredients: [
      { qty: 1, unit: 'lb', item: 'sushi-grade ahi tuna, cubed', group: 'Poke' },
      { qty: 3, unit: 'tbsp', item: 'soy sauce', group: 'Poke Sauce' },
      { qty: 1, unit: 'tbsp', item: 'sesame oil', group: 'Poke Sauce' },
      { qty: 1, unit: 'tsp', item: 'rice vinegar', group: 'Poke Sauce' },
      { qty: 0.5, unit: 'tsp', item: 'sriracha', group: 'Poke Sauce' },
      { qty: 2, unit: 'cups', item: 'sushi rice, cooked', group: 'Base' },
      { qty: 1, unit: 'tbsp', item: 'rice vinegar (for rice)', group: 'Base' },
      { qty: 1, unit: '', item: 'avocado, sliced', group: 'Toppings' },
      { qty: 1, unit: 'cup', item: 'cucumber, diced', group: 'Toppings' },
      { qty: 0.5, unit: 'cup', item: 'edamame, shelled', group: 'Toppings' },
      { qty: 2, unit: '', item: 'green onions, sliced', group: 'Toppings' },
      { qty: 1, unit: 'tbsp', item: 'sesame seeds', group: 'Toppings' },
      { qty: 1, unit: 'sheet', item: 'nori, cut into strips', group: 'Toppings' },
    ],
    steps: [
      { order: 1, instruction: 'Cook sushi rice according to package directions. Once done, fold in 1 tablespoon of rice vinegar and let cool slightly.', timerMinutes: 20 },
      { order: 2, instruction: 'While rice cooks, cut the sushi-grade tuna into half-inch cubes using a very sharp knife.', timerMinutes: null },
      { order: 3, instruction: 'In a medium bowl, whisk together soy sauce, sesame oil, rice vinegar, and sriracha.', timerMinutes: null },
      { order: 4, instruction: 'Gently toss the cubed tuna in the sauce until evenly coated. Refrigerate while you prep toppings.', timerMinutes: null },
      { order: 5, instruction: 'Prepare all toppings: slice the avocado, dice the cucumber, slice the green onions, and cut nori into thin strips.', timerMinutes: null },
      { order: 6, instruction: 'Divide seasoned rice among four bowls. Arrange marinated tuna, avocado slices, cucumber, and edamame on top.', timerMinutes: null },
      { order: 7, instruction: 'Garnish with green onions, sesame seeds, and nori strips. Serve immediately.', timerMinutes: null },
    ],
    notes: 'Only use sushi-grade or sashimi-grade tuna from a trusted fishmonger. The tuna should be deep red with no fishy smell. Keep the tuna as cold as possible until serving. For a budget option, substitute with canned albacore tuna packed in water.',

    communityRating: 4.6,
    communityRatingCount: 255,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-03-01').toISOString(),
  },

  // ============================================================
  // ONE-PAN / SHEET-PAN (5 recipes)
  // ============================================================
  {
    title: 'Sheet Pan Lemon Herb Chicken and Vegetables',
    description: 'Juicy lemon-herb chicken thighs roasted alongside seasonal vegetables on a single sheet pan. Minimal prep, minimal cleanup, and maximum flavor for an effortless weeknight dinner.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/sheet-pan-lemon-herb-chicken.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/sheet-pan-lemon-herb-chicken-prep.jpg', caption: 'Everything arranged on the sheet pan before roasting', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 15,
    cookTime: 35,
    totalTime: 50,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'American',
    region: 'Americas',
    country: 'United States',

    categories: ['Dinner', 'Family Meals'],
    tags: ['high-protein', 'gluten-free', 'dairy-free', 'sheet-pan', 'weeknight-dinner', 'family-friendly', 'meal-prep', 'low-carb'],
    ageGroups: ['teen', 'adult'],
    audience: 'family',

    nutrition: {
      calories: 420, protein: 34, carbs: 22, fat: 22, fiber: 4, sugar: 5, sodium: 530, iron: 2.8,
    },

    ingredients: [
      { qty: 8, unit: '', item: 'bone-in chicken thighs', group: 'Chicken' },
      { qty: 1, unit: 'lb', item: 'baby potatoes, halved', group: 'Vegetables' },
      { qty: 2, unit: 'cups', item: 'broccoli florets', group: 'Vegetables' },
      { qty: 1, unit: 'large', item: 'red onion, cut into wedges', group: 'Vegetables' },
      { qty: 3, unit: 'tbsp', item: 'olive oil', group: 'Dressing' },
      { qty: 2, unit: '', item: 'lemons (1 juiced, 1 sliced)', group: 'Dressing' },
      { qty: 4, unit: 'cloves', item: 'garlic, minced', group: 'Dressing' },
      { qty: 1, unit: 'tbsp', item: 'fresh rosemary, chopped', group: 'Herbs' },
      { qty: 1, unit: 'tbsp', item: 'fresh thyme, chopped', group: 'Herbs' },
      { qty: 0.5, unit: 'tsp', item: 'salt', group: 'Seasoning' },
      { qty: 0.5, unit: 'tsp', item: 'black pepper', group: 'Seasoning' },
    ],
    steps: [
      { order: 1, instruction: 'Preheat oven to 425 degrees F. Line a large rimmed baking sheet with parchment paper.', timerMinutes: null },
      { order: 2, instruction: 'In a small bowl, whisk together olive oil, lemon juice, minced garlic, rosemary, thyme, salt, and pepper.', timerMinutes: null },
      { order: 3, instruction: 'Arrange halved baby potatoes on the baking sheet. Drizzle with half the herb mixture and toss to coat. Push to the edges.', timerMinutes: null },
      { order: 4, instruction: 'Pat chicken thighs dry and place skin-side up in the center of the sheet pan. Brush generously with the remaining herb mixture. Tuck lemon slices around the chicken.', timerMinutes: null },
      { order: 5, instruction: 'Roast for 20 minutes, then add broccoli florets and red onion wedges to the pan around the chicken. Toss vegetables with the pan juices.', timerMinutes: 20 },
      { order: 6, instruction: 'Continue roasting until chicken skin is golden and crispy and internal temperature reads 175 degrees F, and vegetables are tender.', timerMinutes: 15 },
      { order: 7, instruction: 'Let rest for 5 minutes on the pan. Serve directly from the sheet pan for minimal cleanup.', timerMinutes: 5 },
    ],
    notes: 'The beauty of sheet pan dinners is one pan, one oven, one delicious meal. Add the broccoli later so it does not overcook and get mushy. Swap vegetables based on what is in season: asparagus, green beans, or bell peppers all work well.',

    communityRating: 4.8,
    communityRatingCount: 390,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-03-01').toISOString(),
  },
  {
    title: 'One-Pot Creamy Chicken Alfredo',
    description: 'Rich and creamy fettuccine alfredo with tender chicken, all cooked in a single pot. The pasta cooks directly in the sauce for maximum flavor absorption and minimal dishes to wash.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/one-pot-chicken-alfredo.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/one-pot-chicken-alfredo-prep.jpg', caption: 'Chicken searing in the pot', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 10,
    cookTime: 25,
    totalTime: 35,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'Italian',
    region: 'Europe',
    country: 'Italy',

    categories: ['Dinner', 'Family Meals'],
    tags: ['one-pot', 'comfort-food', 'weeknight-dinner', 'family-friendly', 'under-30-min'],
    ageGroups: ['teen', 'adult'],
    audience: 'family',

    nutrition: {
      calories: 580, protein: 35, carbs: 52, fat: 24, fiber: 2, sugar: 3, sodium: 650, iron: 2.2,
    },

    ingredients: [
      { qty: 1.5, unit: 'lbs', item: 'boneless skinless chicken breast, cubed', group: 'Protein' },
      { qty: 12, unit: 'oz', item: 'fettuccine pasta', group: 'Pasta' },
      { qty: 2, unit: 'cups', item: 'chicken broth', group: 'Sauce' },
      { qty: 1.5, unit: 'cups', item: 'whole milk', group: 'Sauce' },
      { qty: 1, unit: 'cup', item: 'heavy cream', group: 'Sauce' },
      { qty: 1, unit: 'cup', item: 'parmesan cheese, freshly grated', group: 'Sauce' },
      { qty: 3, unit: 'cloves', item: 'garlic, minced', group: 'Aromatics' },
      { qty: 2, unit: 'tbsp', item: 'butter', group: 'Cooking' },
      { qty: 1, unit: 'tbsp', item: 'olive oil', group: 'Cooking' },
      { qty: 0.5, unit: 'tsp', item: 'salt', group: 'Seasoning' },
      { qty: 0.25, unit: 'tsp', item: 'black pepper', group: 'Seasoning' },
      { qty: 0.25, unit: 'tsp', item: 'nutmeg', group: 'Seasoning' },
      { qty: 2, unit: 'tbsp', item: 'fresh parsley, chopped', group: 'Garnish' },
    ],
    steps: [
      { order: 1, instruction: 'Heat olive oil and butter in a large deep pot or Dutch oven over medium-high heat. Season cubed chicken with salt and pepper.', timerMinutes: null },
      { order: 2, instruction: 'Sear chicken pieces in a single layer until golden on all sides, about 5-6 minutes. Remove to a plate.', timerMinutes: 6 },
      { order: 3, instruction: 'In the same pot, add minced garlic and cook for 30 seconds until fragrant. Pour in chicken broth, milk, and heavy cream. Bring to a boil.', timerMinutes: null },
      { order: 4, instruction: 'Add fettuccine, pressing it down into the liquid. Reduce heat to medium and cook, stirring frequently to prevent sticking, until pasta is al dente and sauce has thickened.', timerMinutes: 12 },
      { order: 5, instruction: 'Return the seared chicken to the pot. Stir in grated parmesan cheese and nutmeg. Cook for 2-3 minutes until the cheese is melted and the sauce is creamy.', timerMinutes: 3 },
      { order: 6, instruction: 'Remove from heat. The sauce will continue to thicken as it sits. If too thick, stir in a splash of milk.', timerMinutes: null },
      { order: 7, instruction: 'Serve in bowls garnished with fresh parsley and extra parmesan.', timerMinutes: null },
    ],
    notes: 'Stir frequently while the pasta cooks to prevent sticking to the bottom of the pot. The starch released from the pasta cooking directly in the sauce is what makes it so creamy. One pot means one thing to wash; line the pot with a note to soak it immediately after serving.',

    communityRating: 4.7,
    communityRatingCount: 405,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-03-01').toISOString(),
  },
  {
    title: 'Skillet Enchilada Bake',
    description: 'All the flavors of enchiladas made in one skillet with no rolling required. Layers of tortillas, seasoned beef, beans, and melty cheese baked in enchilada sauce for a comforting one-pan dinner.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/skillet-enchilada-bake.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/skillet-enchilada-bake-prep.jpg', caption: 'Layering tortillas and filling in the skillet', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 6,
    prepTime: 15,
    cookTime: 30,
    totalTime: 45,
    difficulty: 'easy',
    spiceLevel: 2,

    cuisine: 'Mexican',
    region: 'Americas',
    country: 'Mexico',

    categories: ['Dinner'],
    tags: ['one-pan', 'comfort-food', 'weeknight-dinner', 'family-friendly', 'freezer-friendly'],
    ageGroups: ['teen', 'adult'],

    nutrition: {
      calories: 510, protein: 28, carbs: 42, fat: 24, fiber: 6, sugar: 5, sodium: 740, iron: 3.5,
    },

    ingredients: [
      { qty: 1, unit: 'lb', item: 'ground beef', group: 'Filling' },
      { qty: 1, unit: 'can (15 oz)', item: 'black beans, drained and rinsed', group: 'Filling' },
      { qty: 1, unit: 'can (15 oz)', item: 'red enchilada sauce', group: 'Sauce' },
      { qty: 8, unit: '', item: 'corn tortillas, cut into quarters', group: 'Layers' },
      { qty: 2, unit: 'cups', item: 'shredded Mexican blend cheese', group: 'Topping' },
      { qty: 1, unit: '', item: 'onion, diced', group: 'Filling' },
      { qty: 2, unit: 'cloves', item: 'garlic, minced', group: 'Filling' },
      { qty: 1, unit: 'tsp', item: 'chili powder', group: 'Seasoning' },
      { qty: 0.5, unit: 'tsp', item: 'cumin', group: 'Seasoning' },
      { qty: 0.5, unit: 'tsp', item: 'salt', group: 'Seasoning' },
      { qty: 0.25, unit: 'cup', item: 'sour cream', group: 'Garnish' },
      { qty: 0.25, unit: 'cup', item: 'fresh cilantro, chopped', group: 'Garnish' },
    ],
    steps: [
      { order: 1, instruction: 'Preheat oven to 375 degrees F. Heat a large oven-safe skillet over medium-high heat.', timerMinutes: null },
      { order: 2, instruction: 'Cook ground beef with diced onion until browned and onion is softened. Drain excess fat.', timerMinutes: 8 },
      { order: 3, instruction: 'Add garlic, chili powder, cumin, and salt. Cook for 1 minute until fragrant.', timerMinutes: 1 },
      { order: 4, instruction: 'Stir in black beans and half the enchilada sauce. Remove from heat.', timerMinutes: null },
      { order: 5, instruction: 'Layer half the tortilla pieces over the meat mixture. Spoon remaining enchilada sauce over the tortillas. Sprinkle with half the cheese. Add the remaining tortilla pieces and top with the rest of the cheese.', timerMinutes: null },
      { order: 6, instruction: 'Cover the skillet with foil and bake for 15 minutes. Remove foil and bake until cheese is bubbly and golden.', timerMinutes: 20 },
      { order: 7, instruction: 'Let rest for 5 minutes before serving. Top with sour cream and fresh cilantro.', timerMinutes: 5 },
    ],
    notes: 'One skillet from stovetop to oven makes this a true one-pan meal. Use an oven-safe skillet, such as cast iron. For a milder version, use mild enchilada sauce. This reheats well and can be frozen in portions for up to 2 months.',

    communityRating: 4.6,
    communityRatingCount: 345,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-03-01').toISOString(),
  },
  {
    title: 'One-Pan Mediterranean Salmon',
    description: 'Baked salmon fillets nestled among cherry tomatoes, olives, artichoke hearts, and capers in a single pan. A vibrant and healthy Mediterranean dinner with virtually no cleanup.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/one-pan-mediterranean-salmon.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/one-pan-mediterranean-salmon-prep.jpg', caption: 'Salmon and vegetables arranged in the pan', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 10,
    cookTime: 20,
    totalTime: 30,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'Mediterranean',
    region: 'Europe',
    country: 'Greece',

    categories: ['Dinner'],
    tags: ['high-protein', 'gluten-free', 'dairy-free', 'one-pan', 'pescatarian', 'low-carb', 'under-30-min', 'weeknight-dinner'],
    ageGroups: ['teen', 'adult'],

    nutrition: {
      calories: 410, protein: 35, carbs: 12, fat: 24, fiber: 3, sugar: 4, sodium: 580, iron: 2.5,
    },

    ingredients: [
      { qty: 4, unit: '', item: 'salmon fillets (6 oz each)', group: 'Fish' },
      { qty: 1, unit: 'pint', item: 'cherry tomatoes, halved', group: 'Vegetables' },
      { qty: 0.5, unit: 'cup', item: 'kalamata olives, halved', group: 'Vegetables' },
      { qty: 1, unit: 'can (14 oz)', item: 'artichoke hearts, drained and quartered', group: 'Vegetables' },
      { qty: 2, unit: 'tbsp', item: 'capers, drained', group: 'Vegetables' },
      { qty: 3, unit: 'tbsp', item: 'olive oil', group: 'Main' },
      { qty: 3, unit: 'cloves', item: 'garlic, sliced', group: 'Aromatics' },
      { qty: 1, unit: '', item: 'lemon, juiced', group: 'Seasoning' },
      { qty: 1, unit: 'tsp', item: 'dried oregano', group: 'Seasoning' },
      { qty: 0.5, unit: 'tsp', item: 'salt', group: 'Seasoning' },
      { qty: 0.25, unit: 'tsp', item: 'black pepper', group: 'Seasoning' },
      { qty: 2, unit: 'tbsp', item: 'fresh basil, torn', group: 'Garnish' },
    ],
    steps: [
      { order: 1, instruction: 'Preheat oven to 400 degrees F.', timerMinutes: null },
      { order: 2, instruction: 'In a large oven-safe skillet or baking dish, toss cherry tomatoes, olives, artichoke hearts, capers, and sliced garlic with 2 tablespoons olive oil, oregano, and a pinch of salt.', timerMinutes: null },
      { order: 3, instruction: 'Spread the vegetable mixture in an even layer. Nestle salmon fillets skin-side down among the vegetables.', timerMinutes: null },
      { order: 4, instruction: 'Drizzle salmon with remaining olive oil and lemon juice. Season with salt and pepper.', timerMinutes: null },
      { order: 5, instruction: 'Bake until salmon flakes easily with a fork and reaches an internal temperature of 145 degrees F, and tomatoes are blistered.', timerMinutes: 18 },
      { order: 6, instruction: 'Garnish with torn fresh basil. Serve directly from the pan with crusty bread to soak up the juices.', timerMinutes: null },
    ],
    notes: 'One pan, one beautiful dinner. The tomatoes, olives, and capers create a briny, savory sauce as they roast alongside the salmon. Serve with crusty bread, couscous, or orzo to make it a more filling meal. Cleanup takes less than 5 minutes.',

    communityRating: 4.8,
    communityRatingCount: 310,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-03-01').toISOString(),
  },
  {
    title: 'Sheet Pan Sausage and Roasted Vegetables',
    description: 'Smoky sausage links roasted with a colorful medley of seasonal vegetables on a single sheet pan. Practically hands-off cooking with minimal cleanup, perfect for busy weeknights.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/sheet-pan-sausage-vegetables.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/sheet-pan-sausage-vegetables-prep.jpg', caption: 'Sausage and vegetables ready for the oven', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 10,
    cookTime: 30,
    totalTime: 40,
    difficulty: 'easy',
    spiceLevel: 1,

    cuisine: 'American',
    region: 'Americas',
    country: 'United States',

    categories: ['Dinner', 'Family Meals'],
    tags: ['gluten-free', 'dairy-free', 'sheet-pan', 'weeknight-dinner', 'family-friendly', 'meal-prep', 'budget-friendly', 'low-carb'],
    ageGroups: ['teen', 'adult'],
    audience: 'family',

    nutrition: {
      calories: 440, protein: 22, carbs: 28, fat: 26, fiber: 5, sugar: 8, sodium: 720, iron: 2.8,
    },

    ingredients: [
      { qty: 1, unit: 'lb', item: 'smoked sausage links, sliced into rounds', group: 'Protein' },
      { qty: 2, unit: 'medium', item: 'bell peppers (any colors), chopped', group: 'Vegetables' },
      { qty: 1, unit: 'medium', item: 'red onion, cut into wedges', group: 'Vegetables' },
      { qty: 2, unit: 'cups', item: 'broccoli florets', group: 'Vegetables' },
      { qty: 1, unit: 'medium', item: 'zucchini, sliced into half-moons', group: 'Vegetables' },
      { qty: 1, unit: 'lb', item: 'baby potatoes, halved', group: 'Vegetables' },
      { qty: 3, unit: 'tbsp', item: 'olive oil', group: 'Main' },
      { qty: 1, unit: 'tsp', item: 'Italian seasoning', group: 'Seasoning' },
      { qty: 0.5, unit: 'tsp', item: 'garlic powder', group: 'Seasoning' },
      { qty: 0.5, unit: 'tsp', item: 'smoked paprika', group: 'Seasoning' },
      { qty: 0.5, unit: 'tsp', item: 'salt', group: 'Seasoning' },
      { qty: 0.25, unit: 'tsp', item: 'black pepper', group: 'Seasoning' },
    ],
    steps: [
      { order: 1, instruction: 'Preheat oven to 425 degrees F. Line a large rimmed baking sheet with parchment paper.', timerMinutes: null },
      { order: 2, instruction: 'Place halved baby potatoes on the baking sheet, toss with 1 tablespoon olive oil, and spread in a single layer. Roast for 10 minutes to give them a head start.', timerMinutes: 10 },
      { order: 3, instruction: 'While potatoes roast, toss sliced sausage, bell peppers, onion, broccoli, and zucchini with remaining olive oil, Italian seasoning, garlic powder, smoked paprika, salt, and pepper.', timerMinutes: null },
      { order: 4, instruction: 'Add the seasoned sausage and vegetables to the sheet pan with the potatoes. Spread in a single layer, avoiding overcrowding.', timerMinutes: null },
      { order: 5, instruction: 'Roast until sausage is browned, vegetables are tender with caramelized edges, and potatoes are fork-tender.', timerMinutes: 20 },
      { order: 6, instruction: 'Serve directly from the sheet pan. The parchment paper means the pan barely needs washing.', timerMinutes: null },
    ],
    notes: 'Line the pan with parchment for truly effortless cleanup. Start the potatoes first since they take the longest to cook. Use any sausage you prefer: chicken sausage for a lighter option, or spicy Italian sausage for more heat. This meal preps beautifully for 4-5 days.',

    communityRating: 4.5,
    communityRatingCount: 335,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-03-01').toISOString(),
  },

  // ============================================================
  // HIGH IRON MEALS (4 recipes)
  // ============================================================
  {
    title: 'Spinach and Beef Stir-Fry',
    description: 'A quick and flavorful stir-fry pairing iron-rich beef strips with a generous heap of fresh spinach in a savory garlic-ginger sauce. One of the most efficient ways to load up on dietary iron.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/spinach-beef-stir-fry.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/spinach-beef-stir-fry-prep.jpg', caption: 'Sliced beef and fresh spinach ready to cook', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 15,
    cookTime: 10,
    totalTime: 25,
    difficulty: 'easy',
    spiceLevel: 1,

    cuisine: 'Chinese',
    region: 'Asia',
    country: 'China',

    categories: ['Dinner'],
    tags: ['high-iron', 'high-protein', 'dairy-free', 'stir-fry', 'under-30-min', 'weeknight-dinner'],
    ageGroups: ['teen', 'adult'],

    nutrition: {
      calories: 380, protein: 32, carbs: 18, fat: 20, fiber: 3, sugar: 5, sodium: 680, iron: 5.8,
    },

    ingredients: [
      { qty: 1, unit: 'lb', item: 'flank steak, thinly sliced against the grain', group: 'Protein' },
      { qty: 6, unit: 'cups', item: 'fresh baby spinach', group: 'Vegetables' },
      { qty: 1, unit: '', item: 'red bell pepper, sliced', group: 'Vegetables' },
      { qty: 3, unit: 'cloves', item: 'garlic, minced', group: 'Sauce' },
      { qty: 1, unit: 'tbsp', item: 'fresh ginger, grated', group: 'Sauce' },
      { qty: 3, unit: 'tbsp', item: 'soy sauce', group: 'Sauce' },
      { qty: 1, unit: 'tbsp', item: 'oyster sauce', group: 'Sauce' },
      { qty: 1, unit: 'tsp', item: 'sesame oil', group: 'Sauce' },
      { qty: 1, unit: 'tsp', item: 'cornstarch', group: 'Sauce' },
      { qty: 2, unit: 'tbsp', item: 'vegetable oil', group: 'Cooking' },
      { qty: 1, unit: 'tbsp', item: 'rice vinegar', group: 'Sauce' },
      { qty: 2, unit: 'cups', item: 'cooked white rice', group: 'Serving' },
    ],
    steps: [
      { order: 1, instruction: 'In a small bowl, whisk together soy sauce, oyster sauce, sesame oil, rice vinegar, and cornstarch. Set sauce aside.', timerMinutes: null },
      { order: 2, instruction: 'Slice flank steak very thinly against the grain. Pat dry with paper towels for the best sear.', timerMinutes: null },
      { order: 3, instruction: 'Heat a wok or large skillet over high heat until smoking. Add 1 tablespoon vegetable oil. Sear beef in a single layer without moving for 1-2 minutes until browned. Flip and cook 1 more minute. Remove to a plate.', timerMinutes: 3 },
      { order: 4, instruction: 'Add remaining oil to the wok. Stir-fry garlic and ginger for 30 seconds until fragrant.', timerMinutes: null },
      { order: 5, instruction: 'Add sliced bell pepper and stir-fry for 2 minutes. Add the spinach in batches, tossing as it wilts.', timerMinutes: 3 },
      { order: 6, instruction: 'Return the beef to the wok. Pour in the sauce and toss everything together until the sauce thickens and coats all ingredients evenly.', timerMinutes: 1 },
      { order: 7, instruction: 'Serve immediately over cooked white rice.', timerMinutes: null },
    ],
    notes: 'Beef and spinach are both excellent sources of iron, and the bell pepper provides vitamin C which significantly enhances iron absorption. For maximum iron absorption, avoid drinking tea or coffee with this meal as tannins can inhibit iron uptake. Slice the beef as thin as possible for the most tender result.',

    communityRating: 4.5,
    communityRatingCount: 270,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-03-01').toISOString(),
  },
  {
    title: 'Chickpea and Spinach Curry',
    description: 'A warming plant-based curry loaded with iron from chickpeas and spinach, simmered in a fragrant tomato and coconut sauce. Proof that you do not need meat to get plenty of iron.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/chickpea-spinach-curry.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/chickpea-spinach-curry-prep.jpg', caption: 'Spices and aromatics ready for the pan', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 10,
    cookTime: 25,
    totalTime: 35,
    difficulty: 'easy',
    spiceLevel: 2,

    cuisine: 'Indian',
    region: 'Asia',
    country: 'India',

    categories: ['Dinner'],
    tags: ['high-iron', 'high-fiber', 'vegan', 'gluten-free', 'dairy-free', 'nut-free', 'one-pot', 'budget-friendly', 'weeknight-dinner', 'meal-prep', 'freezer-friendly'],
    ageGroups: ['teen', 'adult'],

    nutrition: {
      calories: 355, protein: 14, carbs: 42, fat: 15, fiber: 10, sugar: 8, sodium: 520, iron: 6.2,
    },

    ingredients: [
      { qty: 2, unit: 'cans (15 oz each)', item: 'chickpeas, drained and rinsed', group: 'Main' },
      { qty: 5, unit: 'cups', item: 'fresh baby spinach', group: 'Main' },
      { qty: 1, unit: 'can (14 oz)', item: 'diced tomatoes', group: 'Sauce' },
      { qty: 1, unit: 'can (14 oz)', item: 'coconut milk', group: 'Sauce' },
      { qty: 1, unit: 'large', item: 'onion, diced', group: 'Aromatics' },
      { qty: 3, unit: 'cloves', item: 'garlic, minced', group: 'Aromatics' },
      { qty: 1, unit: 'tbsp', item: 'fresh ginger, grated', group: 'Aromatics' },
      { qty: 2, unit: 'tbsp', item: 'olive oil', group: 'Cooking' },
      { qty: 2, unit: 'tsp', item: 'curry powder', group: 'Spices' },
      { qty: 1, unit: 'tsp', item: 'cumin', group: 'Spices' },
      { qty: 0.5, unit: 'tsp', item: 'turmeric', group: 'Spices' },
      { qty: 0.25, unit: 'tsp', item: 'cayenne pepper', group: 'Spices' },
      { qty: 0.5, unit: 'tsp', item: 'salt', group: 'Seasoning' },
      { qty: 1, unit: '', item: 'lime, juiced', group: 'Finishing' },
      { qty: 2, unit: 'cups', item: 'basmati rice, cooked', group: 'Serving' },
    ],
    steps: [
      { order: 1, instruction: 'Heat olive oil in a large pot or Dutch oven over medium heat. Add diced onion and cook until softened and translucent.', timerMinutes: 5 },
      { order: 2, instruction: 'Add garlic and ginger. Cook for 1 minute until fragrant.', timerMinutes: 1 },
      { order: 3, instruction: 'Stir in curry powder, cumin, turmeric, and cayenne. Toast the spices for 30 seconds, stirring constantly.', timerMinutes: null },
      { order: 4, instruction: 'Add diced tomatoes and coconut milk. Stir well and bring to a simmer.', timerMinutes: null },
      { order: 5, instruction: 'Add drained chickpeas and salt. Simmer until the sauce thickens slightly and the flavors meld together.', timerMinutes: 15 },
      { order: 6, instruction: 'Add the fresh spinach in large handfuls, stirring as each batch wilts into the curry.', timerMinutes: 2 },
      { order: 7, instruction: 'Squeeze in lime juice and stir. Taste and adjust seasoning. Serve over basmati rice.', timerMinutes: null },
    ],
    notes: 'Chickpeas and spinach are both excellent sources of plant-based iron. The tomatoes in this recipe provide vitamin C, which boosts iron absorption by up to 6 times. Squeeze extra lime on top for even more vitamin C. This curry freezes beautifully for up to 3 months. Avoid drinking coffee or tea with this meal as they inhibit iron absorption.',

    communityRating: 4.6,
    communityRatingCount: 295,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-03-01').toISOString(),
  },
  {
    title: 'Liver and Onions',
    description: 'The traditional iron powerhouse, pan-seared calves liver with caramelized onions and a rich gravy. A single serving delivers more than a full day\'s recommended iron intake.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/liver-and-onions.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/liver-and-onions-prep.jpg', caption: 'Liver soaking in milk before cooking', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 15,
    cookTime: 25,
    totalTime: 40,
    difficulty: 'medium',
    spiceLevel: 0,

    cuisine: 'British',
    region: 'Europe',
    country: 'United Kingdom',

    categories: ['Dinner'],
    tags: ['high-iron', 'high-protein', 'gluten-free', 'low-carb', 'budget-friendly', 'comfort-food'],
    ageGroups: ['adult'],

    nutrition: {
      calories: 350, protein: 30, carbs: 15, fat: 18, fiber: 1.5, sugar: 6, sodium: 490, iron: 9.5,
    },

    ingredients: [
      { qty: 1, unit: 'lb', item: 'calves liver, sliced 1/2 inch thick', group: 'Main' },
      { qty: 1, unit: 'cup', item: 'whole milk (for soaking)', group: 'Prep' },
      { qty: 3, unit: 'large', item: 'onions, thinly sliced', group: 'Onions' },
      { qty: 3, unit: 'tbsp', item: 'butter, divided', group: 'Cooking' },
      { qty: 1, unit: 'tbsp', item: 'olive oil', group: 'Cooking' },
      { qty: 0.5, unit: 'cup', item: 'beef broth', group: 'Gravy' },
      { qty: 2, unit: 'tbsp', item: 'flour', group: 'Coating' },
      { qty: 0.5, unit: 'tsp', item: 'salt', group: 'Seasoning' },
      { qty: 0.25, unit: 'tsp', item: 'black pepper', group: 'Seasoning' },
      { qty: 1, unit: 'tsp', item: 'fresh thyme leaves', group: 'Seasoning' },
      { qty: 1, unit: 'tbsp', item: 'fresh parsley, chopped', group: 'Garnish' },
    ],
    steps: [
      { order: 1, instruction: 'Soak the liver slices in milk in a shallow dish for at least 30 minutes. This draws out bitterness and tenderizes the meat.', timerMinutes: 30 },
      { order: 2, instruction: 'While liver soaks, heat 2 tablespoons butter and olive oil in a large skillet over medium heat. Add sliced onions and cook slowly, stirring occasionally, until deeply caramelized and golden brown.', timerMinutes: 20 },
      { order: 3, instruction: 'Remove onions to a plate. Increase heat to medium-high.', timerMinutes: null },
      { order: 4, instruction: 'Remove liver from milk and pat completely dry. Season with salt and pepper, then dust lightly with flour on both sides.', timerMinutes: null },
      { order: 5, instruction: 'Add remaining tablespoon of butter to the skillet. When foaming subsides, lay liver slices in the pan. Sear for 2-3 minutes per side. The liver should be slightly pink in the center; do not overcook or it will become tough.', timerMinutes: 5 },
      { order: 6, instruction: 'Remove liver to a warm plate. Add beef broth and thyme to the skillet, scraping up the browned bits. Simmer until reduced by half.', timerMinutes: 3 },
      { order: 7, instruction: 'Return onions to the pan and warm through. Plate the liver, top with caramelized onions and pan gravy, and garnish with parsley.', timerMinutes: null },
    ],
    notes: 'Liver is nature\'s most concentrated source of iron, with one serving providing over 100% of the daily recommended intake. Pair with a side of steamed broccoli or a squeeze of lemon for vitamin C to maximize iron absorption. Do not overcook the liver; it should be slightly pink inside for the best texture. Soaking in milk is essential for removing any bitter taste.',

    communityRating: 3.8,
    communityRatingCount: 125,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-03-01').toISOString(),
  },
  {
    title: 'Dark Chocolate Chia Pudding',
    description: 'A rich and decadent chocolate chia pudding that doubles as a sweet iron-rich treat. Made with dark cocoa powder and chia seeds, two surprisingly potent sources of iron, for a guilt-free dessert.',
    images: [
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/dark-chocolate-chia-pudding.jpg', caption: 'Finished dish', isPrimary: true },
      { url: 'https://cooksmith-recipe-images-recipes.s3.eu-west-2.amazonaws.com/recipes/dark-chocolate-chia-pudding-prep.jpg', caption: 'Chia mixture before setting overnight', isPrimary: false },
    ],
    sourceUrl: '',
    servings: 4,
    prepTime: 10,
    cookTime: 0,
    totalTime: 10,
    difficulty: 'easy',
    spiceLevel: 0,

    cuisine: 'American',
    region: 'Americas',
    country: 'United States',

    categories: ['Dessert', 'Snacks'],
    tags: ['high-iron', 'high-fiber', 'vegetarian', 'gluten-free', 'no-cook', 'make-ahead', 'meal-prep', 'under-15-min'],
    ageGroups: ['teen', 'adult'],

    nutrition: {
      calories: 265, protein: 8, carbs: 30, fat: 13, fiber: 12, sugar: 14, sodium: 65, iron: 4.8,
    },

    ingredients: [
      { qty: 0.5, unit: 'cup', item: 'chia seeds', group: 'Base' },
      { qty: 2, unit: 'cups', item: 'milk (dairy or plant-based)', group: 'Base' },
      { qty: 3, unit: 'tbsp', item: 'dark cocoa powder', group: 'Base' },
      { qty: 3, unit: 'tbsp', item: 'maple syrup', group: 'Sweetener' },
      { qty: 1, unit: 'tsp', item: 'vanilla extract', group: 'Base' },
      { qty: 0.25, unit: 'tsp', item: 'cinnamon', group: 'Spice' },
      { qty: 1, unit: 'pinch', item: 'sea salt', group: 'Spice' },
      { qty: 1, unit: 'oz', item: 'dark chocolate (70%+), shaved', group: 'Topping' },
      { qty: 0.25, unit: 'cup', item: 'fresh raspberries', group: 'Topping' },
    ],
    steps: [
      { order: 1, instruction: 'In a medium bowl or mason jar, whisk together milk, dark cocoa powder, maple syrup, vanilla extract, cinnamon, and sea salt until the cocoa is fully dissolved with no lumps.', timerMinutes: null },
      { order: 2, instruction: 'Add chia seeds and whisk vigorously to combine. Let sit for 5 minutes, then whisk again to prevent clumping.', timerMinutes: 5 },
      { order: 3, instruction: 'Cover and refrigerate for at least 4 hours, or ideally overnight, until the mixture has a thick pudding-like consistency.', timerMinutes: null },
      { order: 4, instruction: 'Before serving, stir well and adjust consistency. Add a splash of milk if too thick.', timerMinutes: null },
      { order: 5, instruction: 'Divide among four serving dishes. Top with shaved dark chocolate and fresh raspberries.', timerMinutes: null },
    ],
    notes: 'Both chia seeds and dark cocoa powder are excellent sources of iron. The raspberries on top provide vitamin C which enhances iron absorption from plant sources. Use 70% or higher dark chocolate for the most iron benefit. This pudding keeps in the refrigerator for up to 5 days, making it perfect for weekly meal prep. Each serving provides about 27% of the daily recommended iron intake.',

    communityRating: 4.4,
    communityRatingCount: 230,

    rating: 0,
    favorite: false,
    cookCount: 0,
    lastCookedAt: null,
    createdAt: new Date('2025-03-01').toISOString(),
  },
];

export default specialtyRecipes;
